module.exports = __webpack_public_path__ + "img/potential-events_rugby-world-cup.03490fa7.jpg";